<div class="container-fluid">
    <div class="row main-heading">
        <div class="col-12">
            <h1>
                <ng-content select="page-header" />
            </h1>
        </div>
    </div>

    <div class="row justify-content-around">
        <div [ngClass]="leftContentWidth()">
            <ng-content select="left-content" />
        </div>

        <div [ngClass]="rightContentWidth()">
            <ng-content select="right-content" />
        </div>

        <div class="col-sm-12">
            <ng-content select="extra-content" />
        </div>
    </div>
</div>
